import { Auth0Provider } from '@auth0/auth0-react';
import { MantineProvider } from '@mantine/core';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { CurrencyProvider } from './currency/CurrencyProvider';
import { LanguageProvider } from './i18n/LanguageProvider';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { mantineTheme } from './theme/mantine';

import '@fontsource-variable/inter';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';

const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;
const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const app =
  AUTH0_DOMAIN && AUTH0_CLIENT_ID ? (
    <React.StrictMode>
      <MantineProvider theme={mantineTheme}>
        <Auth0Provider
          domain={AUTH0_DOMAIN}
          clientId={AUTH0_CLIENT_ID}
          authorizationParams={{
            redirect_uri: window.location.origin,
            audience: AUTH0_AUDIENCE,
            scope: 'openid profile email',
          }}
          onRedirectCallback={appState => {
            const returnTo = appState?.returnTo;
            // Only allow same-origin relative paths
            const safePath =
              typeof returnTo === 'string' && returnTo.startsWith('/')
                ? returnTo
                : window.location.pathname;
            window.history.replaceState({}, document.title, safePath);
          }}
        >
          <LanguageProvider>
            <CurrencyProvider>
              <App />
              <Toaster
                position="top-right"
                toastOptions={{
                  duration: 3000,
                  style: {
                    padding: '10px 14px',
                    fontSize: '13px',
                    borderRadius: '10px',
                    maxWidth: '360px',
                    boxShadow: '0 4px 16px rgba(15, 23, 42, 0.1)',
                  },
                  success: {
                    iconTheme: {
                      primary: '#16a34a',
                      secondary: '#fff',
                    },
                  },
                  error: {
                    iconTheme: {
                      primary: '#ef4444',
                      secondary: '#fff',
                    },
                  },
                }}
              />
            </CurrencyProvider>
          </LanguageProvider>
        </Auth0Provider>
      </MantineProvider>
    </React.StrictMode>
  ) : (
    <React.StrictMode />
  );

root.render(app);

reportWebVitals();
